import FooterContentInjector from './FooterContentInjector';
export default FooterContentInjector;